import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function BookPresentation() {
  return <section className="py-20 bg-white" data-id="element-45">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-47">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-48">
            Esto no es una crisis
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 font-light" data-id="element-49">
            es un libro breve, honesto y profundo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-50">
          {['10 capítulos cortos', 'Para leer en cualquier orden', 'En cualquier momento de tu vida', 'Cuando necesitás parar y ordenar lo que sentís'].map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: idx * 0.1
        }} viewport={{
          once: true
        }} className="flex items-start gap-4 p-4 bg-blue-50/50 rounded-lg border border-blue-100" data-id="element-51">
              <BookOpen className="text-blue-600 w-6 h-6 mt-1 flex-shrink-0" data-id="element-52" />
              <span className="text-lg text-gray-800" data-id="element-53">{feature}</span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 p-6 bg-gray-50 rounded-xl border border-gray-100 inline-block" data-id="element-54">
          <p className="text-xl font-medium text-gray-700" data-id="element-55">
            No te promete soluciones rápidas. <br data-id="element-56" />
            <span className="text-blue-700 font-bold" data-id="element-57">
              Te ofrece claridad emocional.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}